<template>
  <div
    class="home"
    :class="{ fullCover: isFullCover }"
    :style="{ backgroundImage: `url(${getCurCoverPic})` }"
  >
    <div
      class="decorator"
      :style="{ 'background-image': `url(${coverPic || defaultPic})` }"
      v-if="!isFullCover"
    ></div>
    <CoverInfo></CoverInfo>
    <AwardList v-if="hasCoverAward"></AwardList>
  </div>
</template>
<script setup>
import surveyHook from "@/hooks/surveyHook";
import defaultPic from "@/assets/images/default_decorator.png";
import AwardList from "@/components/cover/AwardList.vue";
import CoverInfo from "@/components/cover/coverInfo.vue";
const { coverPic, hasCoverAward, isFullCover, getCurCoverPic } = surveyHook();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/dimen.scss";

.home {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: auto;
  background-size: cover;
  &.fullCover {
    justify-content: flex-end;
  }

  .decorator {
    width: 350px;
    height: 350px;
    background-size: cover !important;
    background-position: center center !important;
    transition: all 0.5s;
    border-radius: 50%;
    @media screen and (orientation: landscape) {
      width: 450px;
      height: 450px;
    }
  }

  @media screen and (orientation: portrait) {
    padding: 180px 20px !important;
  }

  @media screen and (orientation: landscape) {
    flex-direction: row;
    padding: 200px 200px 120px;
  }
}
</style>
